export const environment = {
  production: false,
  configuration: "DEVELOP",
  applicationName: "Arquetipo Angular",
  apiUrl: "https://1d4b3aa7-85de-467c-a2b8-af04be2cad38.mock.pstmn.io/api",
  apiUrlCap: "https://cargacursosgb.bimboconnect.com",
  QrUri: "https://cargacursosgb.bimboconnect.com/",
  Azure: {
    GraphEndpoint: "https://graph.microsoft.com/v1.0/me",
    ActiveDirectory: {
      ClientId: "2660bd9a-38d3-4337-bda7-e651e8fad6aa",
      Authority:
        "https://login.microsoftonline.com/973ba820-4a58-4246-84bf-170e50b3152a",
      RedirectUri: "https://cargacursosgb.bimboconnect.com/",
      RedirectUriLogout:
        "https://cargacursosgb.bimboconnect.com/#/login?returnUrl=%2Fhome",
      RedirectUriLogoutAttendance:
        "https://cargacursosgb.bimboconnect.com/#/registrarAsistencia",
    },
  },
  botEmail: "rpauipath042@grupobimbo.com",
};
